export default __webpack_public_path__ + "583b552b140ca83a7494fd338cf4bcea.ttf";